"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M7 13h2.83L12 15.17V8.83L9.83 11H7z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02S17.48 8.71 16 7.97M5 9v6h4l5 5V4L9 9zm7-.17v6.34L9.83 13H7v-2h2.83z"
}, "1")], 'VolumeDownTwoTone');